import * as React from 'react'

import * as AuthStore from '@store/auth/auth'
import * as SiteStore from '@store/site/site'
import * as UserStore from '@store/user/user'

import useReducer from '@store/useReducer'

import { AuthScope } from '@api/enum'

interface UserTabs {
  drawer: ScreenName[]
  menu: ScreenName[]
}

export const getAdminScreens = (scopes: AuthScope[]): ScreenName[] => {
  const screens: ScreenName[] = []

  if (scopes.includes(AuthScope.AdminUtilisateursTous)) {
    screens.push('admin.users')
  }

  if (
    scopes.includes(AuthScope.AdminUtilisateursSociete) ||
    scopes.includes(AuthScope.AdminUtilisateursToutesSociete)
  ) {
    screens.push('admin.providers')
  }

  if (
    scopes.includes(AuthScope.AdminUtilisateursManifestation) ||
    scopes.includes(AuthScope.AdminUtilisateursToutesManifestation)
  ) {
    screens.push('admin.organizers')
  }

  if (scopes.includes(AuthScope.AdminRoleEdition)) {
    screens.push('admin.roles')
  }

  if (scopes.includes(AuthScope.AdminTacheLancementManuel)) {
    screens.push('admin.jobs')
  }

  if (scopes.includes(AuthScope.AdminPlanCreation)) {
    screens.push('admin.plans')
  }

  return screens
}

export default () => {
  const site = useReducer(SiteStore.store, (s) => s.site)
  const manifestation = useReducer(SiteStore.store, (s) => s.manifestation)
  const scopes = useReducer(AuthStore.store, (s) => s.scopes)
  const user = useReducer(UserStore.store, (s) => s.user)

  return React.useMemo(() => {
    const drawer: ScreenName[] = ['home']
    const menu: ScreenName[] = []

    if (site) {
      if (
        (scopes.includes(AuthScope.DemandesSiteLecture) ||
          scopes.includes(AuthScope.DemandesIncidentLecture) ||
          scopes.includes(AuthScope.DemandesRemiseEnEtatLecture) ||
          scopes.includes(AuthScope.DemandesPrestationLecture)) &&
        ((user && user.typeUtilisateur !== 'ORGANISATEUR') || !!manifestation)
      ) {
        menu.push('incidents')
      }

      if (scopes.includes(AuthScope.EdlSiteLecture)) {
        drawer.push('edlList')
        menu.push('edlList')
      }

      if (user && scopes.includes(AuthScope.CheckListSiteLecture)) {
        drawer.push('checklist')
        menu.push('checklist')
      }

      if (
        scopes.includes(AuthScope.ControleQualiteSiteLecture) ||
        scopes.includes(AuthScope.ControleQualitePrestataireLecture)
      ) {
        drawer.push('controles')
        menu.push('controles')
      }
    }

    // Ajout des screens admin dans le menu web
    getAdminScreens(scopes).forEach((screen) => menu.push(screen))

    drawer.push('account')

    return { drawer, menu } as UserTabs
  }, [site, scopes, user])
}
